/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-07 11:58:13
 * @LastEditors: Andy
 * @LastEditTime: 2022-09-19 15:25:04
 */
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
const iosTitleList: any = {
  关于我们: 'بىز توغرىسىدا',
  个人信息收集清单: 'شەخسىي ئۇچۇر توپلاش تىزىملىكى'
}
function checkisIos(title: any) {
  console.log(1234)
  if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
    if (Object.keys(iosTitleList).includes(title)) {
      window.document.title = iosTitleList[title]
      document.getElementsByTagName('title')[0].innerText = iosTitleList[title]
    }
  }
}
@Module({ dynamic: true, store, name: 'Loyout' })
class Loyout extends VuexModule {
  title = '青书'

  @Mutation
  setTitle(title: any) {
    this.title = title || '青书'
    document.title = this.title
    checkisIos(this.title)
  }
}

export const LoyoutModule = getModule(Loyout)
